<template>
  <div class="main_center" style="margin: 0 0; padding-top: 8px;">
    <div class="content" style="padding: 16px 16px 5px 16px;">
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="年份：">
                <el-select v-model="form.year" value-key="value" style="width: 100%" @change="yearsChange">
                  <el-option v-for="(item, index) in yearsList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关键字：" props="searchKey">
                <el-input v-model="form.searchKey" clearable placeholder="请输入项目编号，项目名称关键字" @keyup.enter.native="seachBtn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <div>
                  <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                  <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>

      <space :left="-16" :right="-16" :bottom="16" />

      <el-table :data="tableData" v-loading="dataListLoading" ref="expertExtractTable" :height="tableMaxHeight" stripe border @sort-change="sortChange">
        <el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" align="center" min-width="150px" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              style="color: #52c41a"
              v-if="scope.row.approvalStatus == 1"
              type="text"
              size="small"
              title="同意"
              @click="operation(scope.row, 1)"
              >同意</el-button
            >
            <el-button
              style="color: #f5222d"
              v-if="scope.row.approvalStatus == 1"
              type="text"
              size="small"
              title="拒绝"
              @click="operation(scope.row, 2)"
              >拒绝</el-button
            >
            <el-button type="text" size="small" title="查看评审进度" @click="router(scope.row)">查看评审进度</el-button>
          </template>
        </el-table-column>
        <el-table-column label="核准状态" prop="approvalStatus" align="left" width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <applyStatus :status="scope.row.approvalStatus" mapName="approvalStatus" />
          </template>
        </el-table-column>
        <el-table-column label="标段名称" prop="bidSectionName" align="left" width="400" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="专家组长" prop="displayName" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="申请时间" prop="submitTime" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="目前评标节点" prop="bidEvaluationNode" align="left" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag type="danger">{{ scope.row.bidEvaluationNode }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请回退到的节点" prop="pushBackNode" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="跳转原因" prop="submitCause" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="项目所属交易中心" prop="tradeName" align="left" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.tradeName }}</el-tag>
          </template>
        </el-table-column>
        <!-- 回复人 回复时间 -->
        <el-table-column label="回复人" prop="replier" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="回复时间" prop="replyTime" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <pagination
        class="limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        :page.sync="pageIndex"
        :limit.sync="pageSize"
        @pagination="paginationChange"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination";
import { nearSixYearsList } from "@/utils/index";
import tags from "./components/tags.vue";
import applyStatus from "./components/applyStatus.vue";
import dayjs from "dayjs";

export default {
  name: "expertExtractList",
  components: {
    space,
    Pagination,
    tags,
    applyStatus,
  },
  data() {
    return {
      form: {
        year: new Date().getFullYear(),
        businessCode: "",
        businessName: "",
        witnessMod: "-1",
        witnessStatus: "-1",
        importantPrj: -1,
        flowName: "",
        tradeId: "", // 交易中心ID
        searchKey: ''
      },
      businessType: "GC",
      moreSearchItem: false,
      yearsList: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      tableMaxHeight: document.documentElement.clientHeight - 275,
      inputHtml:'',
      sortParams: {
        prop: '',
        order: ''
      },
    };
  },
  methods: {

    showView(row) {
      // 判断 row.expireTime 是否过期
      //   const isExpire = dayjs(row.expireTime).isBefore(dayjs());
      return row.applyStatus == 1;
    },
    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission('btn_jz_buswitness_'+this.businessType+'del');
      const hasBtnPermisson = false;
      let tableMaxHeight = document.documentElement.clientHeight - 355 + (hasBtnPermisson ? 0 : 41);
      this.pageSize = parseInt(tableMaxHeight / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
    },
    seachBtn() {
      this.pageIndex = 1;
      this.getList();
    },
    reflash() {
      this.form = {
        year: new Date().getFullYear(),
        searchKey: "",
        businessCode: "",
        businessName: "",
        witnessMod: "-1",
        witnessStatus: "-1",
        importantPrj: -1,
        flowName: "",
        tradeId: "", // 交易中心ID
      };
      this.pageIndex = 1;
      this.getList();
    },
    yearsChange(val) {
      this.yearsList = nearSixYearsList(val);
      this.getList();
    },
    getList() {
      this.$http
        .post(`/evaluationSkip/list`, {
          page: this.pageIndex,
          rows: this.pageSize,
          searchKey: this.form.searchKey,
          orderBy: this.sortParams.prop && this.sortParams.order ? this.sortParams.prop+(this.sortParams.order == "ascending" ? " asc" : " desc"):'',
          filter: {
            auditYear: this.form.year,
            // witnessMod: this.form.witnessMod == "-1" ? "" : this.form.witnessMod,
            // importantPrj: this.form.importantPrj == -1 ? "" : this.form.importantPrj,
            // witnessStatus: "",
            // businessName: this.form.businessName,
            // businessCode: this.form.businessCode,
            // businessType: this.businessType,
            // flowName: this.form.flowName,
            // tradeId: this.form.tradeId,
          },
        })
        .then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
    },
    sortChange({ column, prop, order }) { //排序
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getList();
    },
    paginationChange({ page, limit }) {
      this.pageIndex = page;
      this.pageSize = limit;
      this.getList();
    },
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    submitWorkFlow(v, type, opinionText) {
      const url = `/evaluationSkip/submitWorkFlow`;
      const params = {
        id: v.id,
        processinstanceid: v.processinstanceid,
        variables: {
          commit: type == 1,
          opinion: type == 1 ? "通过" : opinionText,
        },
      };
      this.$http.post(url, params).then((res) => {
        this.$message.success(res.msg || "操作成功");
        this.pageIndex = 1;
        this.getList();
      });
    },
    operation(row, type) {
      const html = `<span style="color: ${type == 1 ? "#52C41A" : "#F5222D"} ">${type == 1 ? "同意" : "拒绝"}</span>`;
      const msg = `确定${html}【${row.bidSectionName}】的流程跳转吗？
        <div style="color: #afaeae">确定后，核准结果将即时返给评标系统</div>
      `;
      if (type == 1 ) {
        this.$confirm(msg, "二次确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        })
          .then((action) => {
            if (action == "confirm") {
              this.submitWorkFlow(row, type);
            }
          })
          .catch(() => {});
      } else {
        this.$prompt(msg, '二次确认', {
            type: "warning",
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            inputValue:'不同意',
            inputValidator: (value) => {
              if (!value) {
                return '请输入拒绝原因';
              }
            },
            inputErrorMessage: '请输入拒绝原因'
          }).then(({ value }) => {
            this.submitWorkFlow(row, type, value);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });       
          });
      }


    },
    router(item) {

      // 1 等待开标 2 开标中，3评标中 4评标结束
      // if (item?.status == 1) {
      //   this.$message.error("暂未开标，请稍候。")
      //   return
      // }

      // if (item?.status == 4 && (item?.estimateHistoryid == 100 || item?.estimateHistoryid == 0)) { // 100 指没有保存实时见证数据，0 指见证数据已提交
      //   this.$message.error("评标已结束")
      //   return
      // }

      this.$router.push({
        name: "estimateBidWitness_detail",
        query: {
          id: item.bidSectionCode,
          roomCode: item.roomCode,
          dataSource: item.dataSource,
          tradePlatfBidSectionId: item.bidId,
          bidSectionCode: item.bidSectionCode,
        },
      });
    },

  },
  activated() {
    this.getList();
  },
  mounted() {
    // this.getList();
    this.yearsList = nearSixYearsList(this.form.year);
    this.ifmove();
    let resizeTag = true;
    let that = this;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
  },
};
</script>
